import { Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import * as React from 'react';

import type { AddressKitInfo } from 'v2/interfaces/addressKit';

import { useStyles } from './styles';
import DialogTitle from '../DialogTitle';

type ConfirmAddressProps = {
  isOpen: boolean;
  setIsOpen: (prev: boolean) => void;
  data: AddressKitInfo;
};

const ConfirmAddress = ({ isOpen, setIsOpen, data: { name } }: ConfirmAddressProps) => {
  const theme = useTheme();
  const classes = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onClose={setIsOpen} fullScreen={isMobile} maxWidth='sm'>
      <DialogTitle onClose={handleClose}>
        <Typography>👍 Confirmação de endereço recebida!</Typography>
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText className={classes.dialogContentContainer}>
          <Typography variant='subtitle1' color='textPrimary' className={classes.bold}>
            Olá {name},
          </Typography>
        </DialogContentText>
        <div className={classes.container}>
          <Typography>
            Agradecemos por confirmar que seu endereço permanece o mesmo. Sua atenção aos detalhes nos ajuda a garantir que seus brindes e
            reconhecimentos cheguem corretamente.
          </Typography>
          <Typography>
            👉<strong>Em breve, você receberá seus prêmios diretamente no endereço confirmado.</strong>👈
          </Typography>
          <Typography>Continue alcançando grandes sucessos no Programa Elite!</Typography>
        </div>
      </DialogContent>
      <DialogActions className={classes.buttonActionsContainer}>
        <Button onClick={handleClose} color='primary' size='large' variant='contained'>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmAddress;
